import { classNames } from "primereact/utils";
import styles from "./MultisportTag.module.scss";
import { Tag } from "../Tag/Tag";
import { CheckmarkSentIcon } from "../../../icons/baseIcons/CheckmarkSentIcon";
import { CancelIcon } from "../../../icons/baseIcons/CancelIcon";
import { PaymentTypes } from "../../../enums";
import { PaymentTypesLabels } from "../../../labels";

// Lime reads as "yes" and is not taken by any other tag in the two calendars.
const ACCEPTED_COLOR = "#bef264";
const NOT_ACCEPTED_COLOR = "#9ca3af";

const MULTISPORT_LABEL = PaymentTypesLabels[PaymentTypes.Multisport];

interface IMultisportTagProps {
  /** False shows the "not accepted" state; lists only ever show accepted classes. */
  isAccepted?: boolean;
  /** Spells the status out ("Приема се MultiSport") instead of only naming MultiSport. */
  showStatus?: boolean;
  className?: string;
}

/**
 * Marks whether a class can be paid for with a MultiSport card. Built from spans only,
 * so it also fits inside a text row (e.g. SectionInfoRow's <p>).
 */
export const MultisportTag = ({
  isAccepted = true,
  showStatus = false,
  className,
}: IMultisportTagProps) => {
  const color = isAccepted ? ACCEPTED_COLOR : NOT_ACCEPTED_COLOR;
  const text = !showStatus
    ? MULTISPORT_LABEL
    : isAccepted
      ? `Приема се ${MULTISPORT_LABEL}`
      : `Не се приема ${MULTISPORT_LABEL}`;

  return (
    <Tag
      as="span"
      className={classNames(styles.tag, className)}
      backgroundColor={color}
      tooltip={showStatus ? undefined : `Приема се карта ${MULTISPORT_LABEL}`}
      label={
        <span className={styles.tag_label}>
          <span className={styles.tag_icon} aria-hidden="true">
            {isAccepted ? (
              <CheckmarkSentIcon color={color} />
            ) : (
              <CancelIcon color={color} />
            )}
          </span>
          <span>{text}</span>
        </span>
      }
    />
  );
};
